module.exports = __webpack_public_path__ + "img/hr-sand-decal-16.190c1045.png";